export default __webpack_public_path__ + "static/media/WordLogo.02092265.png";